import PropTypes from "prop-types"
import { NavLink, Link } from "react-router-dom"
import { last, map, toLower } from "lodash"
import classNames from "classnames"
import Logo from "components/logo"
import ServerNotifications from "modules/server-notifications"
import { LINK, PORTFOLIO } from "../../shapes"
import MobileNav from "../mobile-nav"
import PortfolioSelector from "../portfolio-selector"
import LegacySearch from "components/legacy-search"
import HelpMenu from "modules/help-menu"
import ContextualMenu from "components/contextual-menu"
import { useSaveContextPreferences } from "hooks/preferences"

import "./style.scss"

export default function Nav({ account, portfolioName, links, latestPortfolios, modelId, navigationDisabled, menuItems }) {
  const saveLastLocationPreference = useSaveContextPreferences("navigation.root")

  const path = last(window.location.pathname.split("/"))

  return <div className="nav">
    {!navigationDisabled && <div className="left">
      <MobileNav links={links} portfolioName={portfolioName} modelId={modelId} home={`/${account}/home`} />
      <Link className="logo" to={`/${account}/home`}>
        <Logo />
      </Link>
      <ContextualMenu items={menuItems} />
      <PortfolioSelector portfolioName={portfolioName} latestPortfolios={latestPortfolios} />
      {map(links, link => <NavLink onClick={() => saveLastLocationPreference(link.id)} key={link.id} data-test-class={`nav-${toLower(link.label)}`} className={({ isActive }) => classNames("link", { active: isActive })} to={link.to}>
        <i className={`fa fa-${link.icon}`} />
        {link.label}
      </NavLink>,
      )}
    </div>}
    <div className="center">
      <LegacySearch location={path} modelId={modelId} />
    </div>
    <div className="right">
      <ServerNotifications />
      <HelpMenu modelId={modelId} />
    </div>
  </div>
}

Nav.propTypes = {
  account: PropTypes.string.isRequired,
  links: PropTypes.arrayOf(LINK).isRequired,
  portfolioName: PropTypes.string.isRequired,
  modelId: PropTypes.string.isRequired,
  latestPortfolios: PropTypes.arrayOf(PORTFOLIO).isRequired,
  navigationDisabled: PropTypes.bool.isRequired,
  menuItems: PropTypes.array,
}
